import React from 'react';

export default function Header() {
  return (
    <header className='header'>
      <a href='#' target='_blank' className='header__logo'></a>
    </header>
  );
}
